// BlogCarousel.js

import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import API_Root from '../Constants/API_Root';

class BlogCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: []  // This will hold either blog_items or youtube_items
        };
    }

    componentDidMount() {
        fetch(API_Root + 'admin/get-blog-update-items')
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                // If the prop itemType is 'youtube', use youtube_items; otherwise use blog_items.
                const itemsToUse = this.props.itemType === 'youtube'
                    ? data.youtube_items
                    : data.blog_items;
                this.setState({ items: itemsToUse });
            })
            .catch(error => {
                console.error("Error fetching blog update items:", error);
            });
    }

    render() {
        const { openUrl } = this.props;
        const { items } = this.state;

        const responsive = {
            superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
            desktop: { breakpoint: { max: 3000, min: 1024 }, items: 3 },
            tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
            mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
        };

        return (
            <div className='carousel-container'>
                <Carousel 
                    responsive={responsive}
                    autoPlay={true} 
                    autoPlaySpeed={3500}
                    infinite={true}
                >
                    {items.map((item, index) => (
                        <div className="carousel-content" key={index}>
                            <div 
                                className='carousal-img'
                                style={{ backgroundImage: `url(${item.img_url})` }}
                            >
                                <div className='carousel-content-title'>{item.title}</div>
                                <div className='carousal-btn-container'>
                                    <Button className='carousal-btn' onClick={() => openUrl(item.url)}>
                                        {this.props.itemType === 'youtube' ? 'Watch Video' : 'Read More'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        );
    }
}

export default BlogCarousel;
